<script setup lang="ts">
import monsterUrl from '/assets/monster/glad.png';
import SpeechBubble from '@/components/SpeechBubble.vue';
</script>

<template>
  <div class="flex justify-center w-full">
    <!-- <div class="relative flex flex-col md:flex-row-reverse items-center  justify-between h-full md:pt-24">
      <div class="relative flex justify-center ">
        <speech-bubble
          color="green"
          class="w-[30%] md:w-[calc(100%-200px)] md:landscape:w-[40%] md:rotate-90"
        >
          <div class="text-[16px] py-12 md:-rotate-90">
            Nu ett test som visar<br />om livet känns<br />begripligt,
            hanterbart<br />och meningsfullt.<br />Frivilligt att svara på -
            <strong>om</strong> din mentor sagt det!
          </div>
        </speech-bubble>
      </div>
      <div class="flex justify-center">
        <img
          class="monster !w-[80%] md:!w-[70%] lg:!w-[60%] md:bottom-6 bottom-[36%] mt-[-10%] md:landscape:bottom-[2%]"
          :src="monsterUrl"
        />
      </div>
    </div> -->

    
      <div class="flex justify-center flex-col items-center relative mx-auto">
        <div class="relative flex justify-center items-center">
          <speech-bubble
            color="green"
            class="w-[200px] md:w-[220px]"
          />

          <div
            class="absolute lg:text-[15px] text-sm text-center w-[70%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          >
          Nu ett spännande test om du tycker livet känns begripligt, hanterbart och begripligt. Frivilligt-om din mentor sagt det!
          </div>
        </div>
        <img class="monster shrink-0 -mt-4" :src="monsterUrl" />
      </div>
  </div>
</template>
